export const COLOR = '0.5s ease-out';
export const PANES = '0.5s ease-out';
